<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Proyecto</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
      <inertia-link class="btn-indigo" :href="route('proyectos.create')">
        <span>Agregar</span>
        <span class="hidden md:inline">Proyecto</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Nombre</th>
          <th class="px-6 pt-6 pb-4">Estado</th>
          <th class="px-6 pt-6 pb-4" colspan="2">Fecha Creado</th>
        </tr>
        <tr v-for="proyecto in proyectos.data" :key="proyecto.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('proyectos.edit', proyecto.id)" tabindex="-1">
              {{ proyecto.nombres }}
            </inertia-link>
          </td>
          <td class="border-t" v-if="proyecto!=null">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('proyectos.edit', proyecto.id)">
              {{  proyecto.estado }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('proyectos.edit', proyecto.id)" tabindex="-1">
                {{ proyecto.created_at }}
            </inertia-link>
          </td>
         
          <td class="border-t w-px">
            <inertia-link class="px-4 flex items-center" :href="route('proyectos.edit', proyecto.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="proyectos.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No Encontramos Proyectos</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="proyectos.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  metaInfo: { title: 'Proyectos' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    proyectos: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('proyectos'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
